'use client';

import { type ReactNode } from 'react';
import { FormControlLabel } from '@/components/ui/formControlLabel';
import { Radio, RadioGroup } from '@/components/ui/radio';
import { ListFilterDTO } from '@/features/filters/types/filters.dto';
import { productListUpdateFilters } from '@/features/products/state/list/actions';
import {
  useProductListDispatch,
  useProductListSelectedFilters
} from '@/features/products/state/list/context';
import { FilterLabel } from '@/features/products/types/filterLabel';

interface RatingProductsFilterProps extends ListFilterDTO {
  expanded?: boolean;
  onFilterChange?: (code: string, filterCode: string) => void;
  renderFilterLabel: (FilterLabel: FilterLabel) => ReactNode;
}

export const RatingProductsFilter = ({
  title,
  items,
  code,
  onFilterChange,
  renderFilterLabel
}: RatingProductsFilterProps) => {
  // const { state, dispatch } = useProductList();
  const dispatch = useProductListDispatch();
  const selectedFilters = useProductListSelectedFilters();

  const handleFiltersChange = (filterCode: string) => {
    dispatch(
      productListUpdateFilters({
        filterCategoryCode: code,
        code: filterCode
      })
    );
    if (onFilterChange) {
      onFilterChange(code, filterCode);
    }
  };

  if (!items.length) return;

  return (
    <RadioGroup value={String(selectedFilters[code]?.[0] || '')}>
      {items.map((filter, index) => (
        <div key={index} className="flex flex-col">
          <FormControlLabel
            value={filter.code}
            control={
              <Radio
                onClick={(e) => {
                  const currentValue = selectedFilters[code]?.[0];
                  const newValue = currentValue === filter.code ? '' : filter.code;
                  handleFiltersChange(newValue);
                }}
              />
            }
            label={renderFilterLabel({ filter })}
            slotProps={{
              typography: {
                component: 'span',
                className: 'text-sm'
              }
            }}
          />
        </div>
      ))}
    </RadioGroup>
  );
};
